import './DarkThemeControl.css';
import React from 'react';
import { handleAnalitics } from "../../utils/tealium";
var DarkThemeControl = function DarkThemeControl(_ref) {
  var handleClick = _ref.handleClick,
    value = _ref.value,
    label = _ref.label,
    analytics = _ref.analytics,
    params = _ref.params;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "switch__field"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-small switch__text"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "switch"
  }, /*#__PURE__*/React.createElement("label", {
    title: label,
    "aria-label": label,
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.target.click();
      }
    }
  }, /*#__PURE__*/React.createElement("input", {
    title: label,
    "aria-label": label,
    defaultChecked: value,
    className: "fp__checkbox",
    type: "checkbox",
    value: value ? value.toString() : 'true',
    tabIndex: -1,
    onChange: function onChange(e) {
      handleClick(!value);
      handleAnalitics({
        params: params,
        title: !value ? 'off' : 'on',
        objectParamName: "Dark Mode Param",
        objectParams: analytics
      });
    },
    id: "switch-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "switch__shape"
  }))))));
};
var commonStyles = "cpddl2r";
var ltrStyles = "l1bik6hy";
var rtlStyles = "r1neioj3";
export default DarkThemeControl;